module.exports = __webpack_public_path__ + "static/media/bg-pattern-how-we-work-mobile.a4de14b0.svg";